import { SIDE_MENU_CATEGORIES } from './sideMenuCategories';
import { isFashionCuratedCategory } from './fashionCuratedCategories';

/**
 * Hobbies & More — every pre-owned marketplace category that is not fashion.
 */
export const HOBBIES_FINDS_CATEGORY_VALUES = [
  'Toys & Video Games',
  'Arts & Crafts',
  'Sports & Outdoors',
  'Books',
  'Stationary',
  'Musical Instruments',
  'Computers & Electronics',
  'Home & Kitchen',
  'Home & Garden',
  'Baby',
  'Pet Supplies',
  'Automotive',
  'Tools & Home Improvement',
  'Tools',
  'Health',
];

/** Legacy marketplace category values that belong in Hobbies & More. */
export const HOBBIES_FINDS_LEGACY_CATEGORY_VALUES = [
  'Sports',
  'Toys',
  'Art',
  'Games',
  'Music',
  // Kept for existing listings only — no longer offered in create/browse pickers.
  'Other',
];

/** Values sent to the browse API when showing all Hobbies & More (includes legacy rows). */
export const HOBBIES_FINDS_API_CATEGORY_VALUES = [
  ...HOBBIES_FINDS_CATEGORY_VALUES,
  ...HOBBIES_FINDS_LEGACY_CATEGORY_VALUES,
];

export function getHobbiesFindsBrowseApiCategories() {
  return HOBBIES_FINDS_API_CATEGORY_VALUES.join(',');
}

/** True for any non-fashion pre-owned category (Hobbies & More hub). */
export function isHobbiesFindsCategory(category) {
  if (typeof category !== 'string') return false;
  const trimmed = category.trim();
  if (!trimmed) return false;
  return !isFashionCuratedCategory(trimmed);
}

export const MUSICAL_INSTRUMENTS_SUBCATEGORIES = [
  'Guitars & Basses',
  'Keyboards & Pianos',
  'Drums & Percussion',
  'Wind & Brass',
  'String Instruments',
  'DJ & Recording Equipment',
  'Amplifiers & Effects',
  'Accessories & Parts',
];

export const HOBBIES_FINDS_BROWSE_CATEGORIES = [
  { name: 'All', icon: '🎯', value: '' },
  { name: 'Toys & Games', icon: '🧸', value: 'Toys & Video Games' },
  { name: 'Arts & Crafts', icon: '🎨', value: 'Arts & Crafts' },
  { name: 'Sports', icon: '⚽', value: 'Sports & Outdoors' },
  { name: 'Books', icon: '📚', value: 'Books' },
  { name: 'Stationary', icon: '✏️', value: 'Stationary' },
  { name: 'Music', icon: '🎸', value: 'Musical Instruments' },
  { name: 'Electronics', icon: '💻', value: 'Computers & Electronics' },
  { name: 'Home', icon: '🏡', value: 'Home & Kitchen' },
  { name: 'Baby', icon: '👶', value: 'Baby' },
  { name: 'Pets', icon: '🐾', value: 'Pet Supplies' },
  { name: 'Auto', icon: '🚗', value: 'Automotive' },
  { name: 'Tools', icon: '🔧', value: 'Tools & Home Improvement' },
];

/** Side-menu slice used on the Hobbies & More browse page. */
export const HOBBIES_FINDS_SIDE_MENU_CATEGORIES = {
  'Toys & Video Games': SIDE_MENU_CATEGORIES['Toys & Video Games'],
  'Arts & Crafts': {
    categoryValue: 'Arts & Crafts',
    subcategories: SIDE_MENU_CATEGORIES['Arts & Crafts']?.subcategories || [],
  },
  'Sports & Outdoors': {
    categoryValue: 'Sports & Outdoors',
    subcategories:
      SIDE_MENU_CATEGORIES['Sports and Outdoors']?.subcategories || [
        'Exercise & Fitness',
        'Outdoor Recreation',
        'Sports Equipment',
      ],
  },
  Books: SIDE_MENU_CATEGORIES.Books,
  Stationary: {
    categoryValue: 'Stationary',
    subcategories: SIDE_MENU_CATEGORIES.Stationary?.subcategories || [],
  },
  'Musical Instruments': {
    categoryValue: 'Musical Instruments',
    subcategories: [...MUSICAL_INSTRUMENTS_SUBCATEGORIES],
  },
  'Computers & Electronics': SIDE_MENU_CATEGORIES['Computers & Electronics'],
  'Home & Kitchen': SIDE_MENU_CATEGORIES['Home and Kitchen'],
  Baby: SIDE_MENU_CATEGORIES.Baby,
  'Pet Supplies': SIDE_MENU_CATEGORIES['Pet supplies'],
  Automotive: {
    categoryValue: 'Automotive',
    subcategories: SIDE_MENU_CATEGORIES.Automotive?.subcategories || [],
  },
  'Tools & Home Improvement': {
    categoryValue: 'Tools & Home Improvement',
    subcategories: SIDE_MENU_CATEGORIES['Tools & Home Improvement']?.subcategories || [],
  },
};

export const HOBBIES_FINDS_ITEM_CATEGORIES = [
  'Toys & Video Games',
  'Arts & Crafts',
  'Sports & Outdoors',
  'Books',
  'Stationary',
  'Musical Instruments',
  'Computers & Electronics',
  'Home & Kitchen',
  'Baby',
  'Pet Supplies',
  'Automotive',
  'Tools & Home Improvement',
];
